// A collection of basic, re-usable components

import styled from '@emotion/styled';
import { FileUploadContainer } from 'components/FileUpload/FileUpload.styles';

export const Row = styled.div`
  display: flex;
`;

export const RowAlignCenter = styled(Row)`
  align-items: center;
`;

export const MarginLeftUploadContainer = styled(FileUploadContainer)`
  margin-left: 1rem;
`;
